import { render, staticRenderFns } from "./orderShow.vue?vue&type=template&id=a70ab8c2&"
import script from "./orderShow.vue?vue&type=script&lang=js&"
export * from "./orderShow.vue?vue&type=script&lang=js&"
import style0 from "./orderShow.vue?vue&type=style&index=0&id=a70ab8c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports